"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "avocado", {
  enumerable: true,
  get: function get() {
    return _color.avocado;
  }
});
Object.defineProperty(exports, "black", {
  enumerable: true,
  get: function get() {
    return _color.black;
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function get() {
    return _color.blue;
  }
});
exports.coal = void 0;
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function get() {
    return _color.green;
  }
});
Object.defineProperty(exports, "grey", {
  enumerable: true,
  get: function get() {
    return _color.grey;
  }
});
Object.defineProperty(exports, "lime", {
  enumerable: true,
  get: function get() {
    return _color.lime;
  }
});
Object.defineProperty(exports, "purple", {
  enumerable: true,
  get: function get() {
    return _color.purple;
  }
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function get() {
    return _color.red;
  }
});
Object.defineProperty(exports, "yellow", {
  enumerable: true,
  get: function get() {
    return _color.yellow;
  }
});
var _color = require("../../tokens/color");
var coal = exports.coal = _color.black;